import { RouteRecordRaw } from "vue-router";

export default {
  path: "/:type/:projectId/:clientId",
  name: "LivePage",
  component: () => import("@/views/live/LivePage.vue"),
  meta: {
    title: "播出",
    ignoreAuth: true,
    hideMenu: true,
  },
} as RouteRecordRaw;
